var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-allowed-page"},[_c('error-layout',[_c('h1',[_vm._v("You don't have access")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }